import { render, staticRenderFns } from "./TestHistory.vue?vue&type=template&id=fb81a392&"
import script from "./TestHistory.vue?vue&type=script&lang=js&"
export * from "./TestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports